export const AGE_GROUPS = [
  {
    label: 'Below 5 years',
    value: 'Below 5 years'
  },
  {
    label: '6 -10 years',
    value: '6 -10 years'
  },
  {
    label: '11 - 17 years',
    value: '11 - 17 years'
  },
  {
    label: '18 - 30 years',
    value: '18 - 30 years'
  },
  {
    label: '30 - 40 years',
    value: '30 - 40 years'
  },
  {
    label: 'Above 40 years',
    value: 'Above 40 years'
  }
];
